<template>
  <div class="page-view">
    <div class="page-search-view">
      <el-form :inline="true" ref="pageForm">
        <div class="search-param-view">
          <div class="search-view">
            <div class="search-item-view">
              <el-form-item label="发布人">
                <el-select
                    v-model="searchData.platformUserId"
                    :clearable="true"
                    placeholder="请选择发布人">
                  <el-option
                      v-for="item in platformUserOptions"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="search-item-view">
              <el-form-item label="视频标题">
                <el-input
                        v-model="searchData.videoTitle"
                        placeholder="视频标题"
                ></el-input>
              </el-form-item>
            </div>
            <div class="search-item-view">
              <el-form-item label="视频简介">
                <el-input
                        v-model="searchData.videoText"
                        placeholder="视频简介"
                ></el-input>
              </el-form-item>
            </div>
            <div class="search-item-view">
              <el-form-item label="视频状态">
                <el-select
                    v-model="searchData.videoStatus"
                    :clearable="true"
                    placeholder="请选择视频状态">
                  <el-option
                      v-for="item in videoStatusOption"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="search-view">
            <div class="search-item-view">
              <el-form-item>
                <el-button size="mini" @click="handleSearch" icon="search" type="primary">搜索</el-button>
              </el-form-item>
            </div>
            <div class="search-item-view">
              <el-form-item>
                <el-button size="mini" type="primary" @click="resetSearchForm">重置</el-button>
              </el-form-item>
            </div>
            <div class="search-item-view" v-if="isAuth('videoData:batchDelete')">
              <el-form-item>
                <el-button size="mini" type="danger" @click="showDeleteBatchModal">批量删除</el-button>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <el-table
      :data="dataList"
      border
      row-key="id"
      lazy
      @selection-change="handleSelectionChange"
      size="mini"
    >
      <el-table-column
        type="selection"
        fixed="left"
        width="55">
      </el-table-column>
      <el-table-column
              prop="id"
              label="标识"
              fixed="left"
              width="55"
              align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column
        prop="platformUserId"
        label="发布人"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag size="medium">{{handleTypeByValue(scope.row.platformUserId,platformUserOptions)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="videoTitle"
        label="视频标题"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="videoText"
        label="视频简介"
        header-align="center"
        align="center"
        width="200px"
      >
        <template slot-scope="scope">
          <el-tag size="medium" @click="previewVideoText(scope.row)">点击预览简介</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="faceUrl"
        label="封面图"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <img @click="handlePreView(handleImageUrl(scope.row.faceUrl))"
               :src="handleImageUrl(scope.row.faceUrl)" style="width: 30px;height: 30px;border-radius: 5px;"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="videoUrl"
        label="视频查看"
        header-align="center"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-tag size="medium" @click="handlePreviewVideo(scope.row)">点击预览视频</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="tagNum"
        label="点赞数"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="starNum"
        label="平均评分"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="videoStatus"
        label="视频状态"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag size="medium">{{handleTypeByValue(scope.row.videoStatus,videoStatusOption)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="operatorId"
        label="创建人"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag size="medium">{{handleTypeByValue(scope.row.operatorId,platformUserOptions)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="300"
        header-align="center"
        align="center">
        <template slot-scope="scope">
          <div class="operation-view">
            <div class="operation-button-view" v-if="isAuth('videoData:view')">
              <el-button @click="handleViewParticulars(scope.row)"
                         icon="el-icon-search"
                         type="primary"
                         size="mini">
                查看
              </el-button>
            </div>
            <div class="operation-button-view" v-if="isAuth('videoData:edit')">
              <el-button @click="handleUpdate(scope.row)"
                         icon="el-icon-s-check"
                         type="warning"
                         size="mini">
                审核视频
              </el-button>
            </div>
            <div class="operation-button-view" v-if="isAuth('videoData:deleteOne')">
              <el-button @click="showDeleteOneModal(scope.row)"
                         :loading="deleteButtonLoading"
                         icon="el-icon-delete"
                         type="danger"
                         size="mini">
                删除
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-view">
     <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :background="true"
       :current-page="paginationData.currentPage"
       :page-sizes="[5, 10, 60, 80, 100, 200, 300]"
       :page-size="paginationData.itemsPerPage"
       layout="total, sizes, prev, pager, next, jumper"
       :total="paginationData.totalCount">
     </el-pagination>
    </div>
    <el-dialog :visible.sync="previewVideoTextVisible"append-to-body title="查看视频简介">
      <div class="video-text-item">
        {{videoText}}
      </div>
    </el-dialog>
    <!--视频预览-->
    <el-dialog :visible.sync="previewVideoVisible"append-to-body title="视频预览">
      <div class="video-item">
        <vueMiniPlayer ref="vueMiniPlayer"
                       :video="videoItem" :mutex="true"
                       @fullscreen="handleFullscreen" />
      </div>
    </el-dialog>
    <!--图片预览-->
    <el-dialog :visible.sync="previewVisible"  title="图片预览">
      <img width="100%" :src="previewImageUrl" alt="" />
    </el-dialog>
    <!--删除确认框-->
    <el-dialog
      title="提示"
      :visible.sync="deleteVisible"
      width="30%">
        <span>需要删除该条么?</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleDeleteCancel" size="mini">取 消</el-button>
          <el-button type="primary"
                     @click="handleDeleteOne"
                     :loading="deleteButtonLoading"
                     size="mini">
            确 定
          </el-button>
      </span>
    </el-dialog>
    <!--批量删除确认框-->
    <el-dialog
      title="提示"
      :visible.sync="batchDeleteVisible"
      width="30%">
    <span style="font-weight: bold;color: #ee0620;font-size: 20px;">
      需要删除选择的{{multipleSelection.length}}条数据么?
    </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDeleteBatchCancel" size="mini">取 消</el-button>
        <el-button type="primary"
                   @click="handleDeleteBatch"
                   :loading="batchDeleteButtonLoading"
                   size="mini">
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!--数据更新-->
    <ItemAudit ref="itemAudit"
              @handleSuccess="handleAuditSuccess">
    </ItemAudit>
    <!--详情信息-->
    <ItemParticulars
            ref="itemParticulars">
    </ItemParticulars>
  </div>
</template>

<script>
import pageTable from "@/components/pageTable/pageTable.vue";
import Api from "@/services";
import MixinWx from "@/mixin/authUser";
import ItemAudit from "./ItemAudit.vue";
import ItemParticulars from "./ItemParticulars.vue";
export default {
  components: {
    pageTable,
    ItemAudit:ItemAudit,
    ItemParticulars:ItemParticulars,
  },
  mixins: [MixinWx],
  data() {
    return {
      //-----------------------------
      videoStatusOption:this.$commonOptions.videoStatusOption,
      platformUserOptions:[],
      videoText:'',
      videoItem:{
        url: '',
        cover: '',
        muted: false,
        loop: false,
        preload: 'auto',
        poster: '',
        volume: 1,
        autoplay: false
      },
      previewVideoVisible:false,
      previewVideoTextVisible:false,
      //-----------------------------
      videoDataOptions:[],
      authUserOptions:[],
      deleteVisible:false,
      batchDeleteVisible:false,
      needDeleteItem:{},
      previewImageUrl:'',
      previewVisible:false,
      deleteButtonLoading:false,
      batchDeleteButtonLoading:false,
      paginationData: {
        itemsPerPage: 10,
        totalCount: 0,
        currentPage:1
      },
      multipleSelection:[],
      dataList: [],
      searchData: {
        platformUserId:'',
        videoTitle:'',
        videoText:'',
        faceUrl:'',
        videoUrl:'',
        tagNum:'',
        starNum:'',
        videoStatus:'',
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    //预览视频简介
    previewVideoText(data){
      console.log('previewVideoText:'+JSON.stringify(data))
      if(!data){
        return;
      }
      this.videoText = data.videoText;
      this.previewVideoTextVisible = true;
    },
    //视频预览
    handlePreviewVideo(data){
      console.log('handlePreviewVideo:'+JSON.stringify(data))
      if(!data){
        return;
      }
      let faceUrl = data.faceUrl
      let videoUrl = data.videoUrl

      this.videoItem.url = this.handleFileUrl(videoUrl)
      this.videoItem.cover = this.handleFileUrl(faceUrl)

      this.previewVideoVisible = true;
    },
    handleFullscreen(){},
    async queryAllPlatformUser(){
      try {
        const loading = this.$loading({
          lock: true,
          text: "正在请求。。。",
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.8)'
        });
        Api.queryAllPlatformUser({}).then((res) => {
          if (res.success) {
            console.log('res:'+JSON.stringify(res))
            if(this.$isNull(res)){
              return;
            }
            let data = res.data
            if(this.$isNull(data)){
              return;
            }
            this.platformUserOptions = new Array();
            data.map((item) => {
              let options = {
                'text':item.userName,
                'value':item.platformUserId
              }
              this.platformUserOptions.push(options)
            })
            console.log('this.platformUserOptions:'+JSON.stringify(this.platformUserOptions))
            loading.close();
          } else {
            loading.close();
            this.$message.error('服务器异常');
          }
        });
      } catch (error) {
        loading.close();
        this.$message.error(error.message || error.msg || "服务器异常");
      }
    },
    async handleVideoDataChange(value){
      this.searchData.videoDataId = value
    },
    async queryAllVideoData(){
      try {
        const loading = this.$loading({
          lock: true,
          text: "正在请求。。。",
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.8)'
        });
        Api.queryAllVideoData({}).then((res) => {
          if (res.success) {
            console.log('res:'+JSON.stringify(res))
            if(this.$isNull(res)){
              return;
            }
            let data = res.data
            if(this.$isNull(data)){
              return;
            }
            this.videoDataOptions = new Array();
            data.map((item) => {
              let options = {
                'text':item.videoDataName,
                'value':item.videoDataId
              }
              this.videoDataOptions.push(options)
            })
            console.log('this.videoDataOptions:'+JSON.stringify(this.videoDataOptions))
            loading.close();
          } else {
            loading.close();
            this.$message.error('服务器异常');
          }
        });
      } catch (error) {
        loading.close();
        this.$message.error(error.message || error.msg || "服务器异常");
      }
    },
    handleTypeByValue(value,optionList){
      if(this.$isNull(value)){
          console.log('返回空')
          return '无'
      }
      if(this.$isNull(optionList)){
          console.log('optionList返回空')
          return '';
      }
      let result =
          optionList.find(item => item.value == value);
      if(!this.$isNull(result)){
          return result.text
      }else{
          return '无'
      }
    },
    // 重置控件
    resetSearchForm() {
      this.searchData = {
          platformUserId:'',
          videoTitle:'',
          videoText:'',
          faceUrl:'',
          videoUrl:'',
          tagNum:'',
          starNum:'',
          videoStatus:'',
      };
      this.queryPageList();
    },
    handleViewParticulars(data){
      this.$refs.itemParticulars.init(data)
    },
    //点击取消删除
    handleDeleteCancel(){
      this.needDeleteItem = {

      }
      this.deleteVisible = false;
    },
    //点击取消删除
    handleDeleteBatchCancel(){
      this.batchDeleteVisible = false;
    },
    //点击批量删除
    handleDeleteBatch(){
      this.batchDelete()
    },
    //点击删除
    handleDeleteOne(){
      this.deleteOne(this.needDeleteItem)
    },
    //展示批量删除弹窗
    showDeleteBatchModal(){
      let multipleSelection = this.multipleSelection
      if(this.$isNull(multipleSelection)){
          this.$message.error(`请选择需要删除的数据`);
          return;
      }
      if(multipleSelection.length == 0){
          this.$message.error(`请选择需要删除的数据`);
          return;
      }
      this.batchDeleteVisible = true
    },
    //展示删除弹窗
    showDeleteOneModal(data){
      this.needDeleteItem = {
          ...data
      }
      this.deleteVisible = true
    },
    handlePreView(url){
      if(this.$isNull(url)){
          return;
      }
      this.previewImageUrl = url
      this.previewVisible = true
    },
    handleSizeChange(val){
      console.log(`每页 ${val} 条`);
      this.paginationData.itemsPerPage = val
      this.queryPageList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.paginationData.currentPage = val
      this.queryPageList();
    },
    handleSelectionChange(val){
      console.log('val:'+JSON.stringify(val))
      this.multipleSelection = val;
    },
    //处理单个删除
    deleteOne(data){
      let mainIdList = new Array();
      mainIdList.push(data.videoDataId)
      this.deleteButtonLoading = true
      Api.batchDeleteVideoData({
          mainIdList:mainIdList
      }).then((res) => {
        //console.log('res:'+JSON.stringify(res))
        if (res.success) {
            this.handleSearch()
        }else{
            this.$message.error(res.message || res.msg || "服务器异常");
        }
        this.needDeleteItem = {}
        this.deleteButtonLoading = false
        this.deleteVisible = false;
      })
    },
    //处理批量删除
    batchDelete(){
      this.batchDeleteButtonLoading = true
      let multipleSelection = this.multipleSelection;
      if(this.$isNull(multipleSelection)){
        this.batchDeleteButtonLoading = false
        return;
      }
      if(multipleSelection.length == 0){
        this.batchDeleteButtonLoading = false
        return;
      }
      let mainIdList = new Array();
      multipleSelection.map(item => {
          mainIdList.push(item.videoDataId)
      })
      console.log('mainIdList:'+JSON.stringify(mainIdList))
      if(this.$isNull(mainIdList)){
        this.$message({
            message: '请选择需要删除的数据',
            type: 'success'
        });
        this.batchDeleteButtonLoading = false
        return;
      }
      if(mainIdList.length == 0){
        this.$message({
            message: '请选择需要删除的数据',
            type: 'success'
        });
        this.batchDeleteButtonLoading = false
        return;
      }
      Api.batchDeleteVideoData({
          mainIdList:mainIdList
      }).then((res) => {
        console.log('res:'+JSON.stringify(res))
        if (res.success) {
            this.handleSearch()
        }else{
            this.$message.error(res.message || res.msg || "服务器异常");
        }
        this.batchDeleteVisible = false
        this.batchDeleteButtonLoading = false
      })
    },
    //处理编辑成功
    handleAuditSuccess() {
      this.queryPageList();
    },
    //分页查询集合
    queryPageList() {
      const loading = this.$loading({
        lock: true,
        text: "正在请求。。。",
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      });
      let params = {
        ...this.searchData,
        itemsPerPage: this.paginationData.itemsPerPage,
        currentPage: this.paginationData.currentPage,
      }
      Api.queryVideoDataByPage({
        ...params
      }).then((res) => {
        //console.log('res:'+JSON.stringify(res))
        let data = res.data
        //console.log('data:'+JSON.stringify(data))
        if (res.success) {
          if(data){
            //console.log('data:'+JSON.stringify(data))
            this.paginationData.totalCount = data.totalCount
            this.paginationData.itemsPerPage = data.itemsPerPage
            this.paginationData.currentPage = data.currentPage
            data = data.data
            this.dataList = data;
          }
        }else{
          this.$message.error(res.message || res.msg || "服务器异常");
        }
        loading.close();
      }).catch((error) => {
        console.log(error);
        this.$message.error(error.message || error.msg || "服务器异常");
        loading.close();
      });
    },
    // 初始化数据
    async init() {
      this.authUserOptions = await this.$commonConstants.authUserOptions()
      //await this.queryAllVideoData();
      await this.queryAllPlatformUser();
      this.queryPageList();
    },
    //处理导出
    handleExport(){
      const loading = this.$loading({
        lock: true,
        text: "正在请求。。。",
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      });
      Api.exportVideoDataItem({
        ...this.searchData,
        itemsPerPage: this.paginationData.itemsPerPage,
        currentPage: this.paginationData.currentPage,
      }).then((res) => {

        loading.close();
      }).catch((error) => {
        console.log(error);
        this.$message.error(error.message || error.msg || "服务器异常");
        loading.close();
      });
    },
    // 搜索事件
    handleSearch() {
      this.queryPageList();
    },
    // 处理更新
    handleUpdate(data) {
      if(data){
        let auditData = {
            ...data
        }
        console.log('editData:'+JSON.stringify(auditData))
        this.$refs.itemAudit.showAudit(auditData);
      }else{
        this.$refs.itemAudit.showAudit({});
      }
    },
  },
};
</script>
<style scoped lang="scss">
 .page-view{
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   justify-content: flex-start;
   padding: 20px;
   .page-search-view{
     margin: 20px 20px;
     .search-param-view{
       display: flex;
       flex-direction: column;
       align-items: flex-start;
       justify-content: flex-start;
       .search-view{
         display: flex;
         flex-direction: row;
         align-items: flex-start;
         justify-content: flex-start;
         .search-item-view{

         }
       }
    }
  }
  .operation-view{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .operation-button-view{
      margin: 2px 2px;
    }
  }
  .pagination-view{
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
    //border: 2px solid #15de0f;
  }
  .video-text-item{

  }
}
</style>



// WEBPACK FOOTER //
// ItemList.vue?4f5f642c